import React from 'react';
import PropTypes from 'prop-types';

import DataTable from 'react-data-table-component';
import { FaEye, FaFilePdf } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import { getDisplayName } from '../components/utils.js';

import { useAppState } from '../AppContext';

const GuidelineTable = ({ documentsInTable }) => {
  let [{ documents, selectedDocument }, dispatch] = useAppState();

  const PDFLink = ({ filename, documentId }) => (
    <a
      href={`/api/uploads/${documentId}/${filename}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaFilePdf />
    </a>
  );
  PDFLink.propTypes = {
    filename: PropTypes.string,
    documentId: PropTypes.number
  };

  const columns = [
    {
      name: 'Title',
      selector: 'title',
      sortable: true,
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <PDFLink filename={row.filename} documentId={row.id} />
          &nbsp;<b>{getDisplayName(row)}</b>
        </>
      ),
      grow: 5
    },
    {
      name: 'Organization',
      selector: 'org_name',
      sortable: true,
      grow: 3
    },
    {
      name: 'Organization level',
      selector: 'org_level',
      sortable: true
    },
    {
      name: 'Preview',
      selector: 'title',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <Button
          variant="secondary"
          onClick={() => {
            dispatch({ type: 'SET_SELECTED_DOCUMENT', selectedDocument: row });
            dispatch({ type: 'SET_PAGE_NUMBER', pageNumber: 1 });
          }}
          size="sm"
        >
          <FaEye color={row.id === selectedDocument.id ? 'gold' : 'black'} />{' '}
          View
        </Button>
      )
    }
  ];

  return (
    <>
      <DataTable
        title={`Uploaded Guidelines (${documentsInTable.length} of ${documents.length} files match)`}
        columns={columns}
        data={documentsInTable}
        pagination={true}
        fixedHeader
      />
    </>
  );
};

GuidelineTable.propTypes = {
  documentsInTable: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      org_name: PropTypes.string,
      org_level: PropTypes.string
    })
  )
};

export default GuidelineTable;
